// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3vUQi","sub-header":"_3ZOZm","subHeader":"_3ZOZm","min-price":"_3gTIa","minPrice":"_3gTIa"};